export default class ApiRoute {
    _url: string;

    private constructor(url: string) {
        this._url = url;
    }

    public static Create(url: string): ApiRoute {
        return new ApiRoute(url);
    }

    public WithParameter(name: string, value: any): ApiRoute {
        this._url = this._url.replace('{' + name + '}', value.toString());

        return this;
    }

    public WithAuthorization(tokenType: string, accessToken: string): ApiRoute {
        this._url = this._url + '?Authorization=' + tokenType + '%20' + accessToken;
        return this;
    }

    public AsUrl(): string {
        return this._url;
    }
}
